export enum Role {
  MASTER_ADMIN = "master_admin",
  ADMIN = "admin",
  SELLER = "seller",
}
